import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackdropComponent } from './backdrop.component';

@NgModule({
  declarations: [BackdropComponent],
  exports: [BackdropComponent],
  imports: [CommonModule],
})
export class BackdropModule {}
